import type { RefObject } from "react";
import { useEffect } from "react";

type OutsideClickOptions = {
  excludeSelectors?: string[];
  excludeRefs?: RefObject<HTMLElement | null>[];
};

export function useOutsideClick(
  ref: RefObject<HTMLElement | null>,
  outsideClickHandler: () => void,
  options?: OutsideClickOptions
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target instanceof Element ? event.target : null;
      if (
        ref.current &&
        !ref.current.contains(target) &&
        !options?.excludeSelectors?.some((selector) => target?.closest(selector)) &&
        !options?.excludeRefs?.some((excludeRef) => excludeRef.current?.contains(target))
      ) {
        outsideClickHandler();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, outsideClickHandler, options]);
}
